var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":!!_vm.errorHandlingMessage,"variant":"danger","dismissible":""}},[_vm._v(_vm._s(_vm.errorHandlingMessage))]),(_vm.hasResource)?_c('VendorSummary',{attrs:{"resource":_vm.resource,"hide-locations":true},on:{"resource:updated":_vm.onUpdatedResource}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }